import styled from 'styled-components';
import { motion } from 'framer-motion';

const ViewBackOffice = styled(motion.div)<{ zoom?: boolean; dark?: boolean }>`
  margin: 20px 0;
  /* padding-bottom: 70px; */
  position: relative;
  width: 90%;
  border-radius: 16px;

  @media (min-width: 800px) {
    max-width: 1500px;
    padding: 0px 0px;
  }

  @media (max-width: 800px) {
    width: 100%;
    padding: 0px 0px;
  }

  ${({ dark, theme }) =>
    dark
      ? `
        background-color: ${theme.colors.neutral0};
        

        @media (min-width: 800px) {
    max-width: 1500px;
    padding: 40px;
  }

        @media (max-width: 800px) {
    padding: 20px 20px;
  }
  `
      : ''}

  ${({ zoom }) =>
    zoom
      ? `
    @media only screen and (max-width: 1500px) and (min-width: 800px) {
      zoom: 80%;
    }
  `
      : ''}
`;

export const AnimatedDashboardWrapper = styled(ViewBackOffice)``;
export const AnimatedItemStyled = styled(motion.div)``;
export const AnimatedTabStyled = styled(motion.div)``;
export const AnimatedAuthStyled = styled(motion.div)``;
